import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvoiceOutlinedmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.51 11.046H5.49a.469.469 0 0 0 0 .937h5.02a.469.469 0 0 0 0-.937Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.145 0H1.855c-.288 0-.522.21-.522.469V14.15c0 .125.055.244.153.332l1.536 1.38a.564.564 0 0 0 .738 0l1.167-1.049 1.168 1.05a.55.55 0 0 0 .368.137c.139 0 .271-.05.37-.137L8 14.813l1.167 1.05c.098.088.23.137.369.137a.56.56 0 0 0 .369-.137l1.167-1.05 1.168 1.05a.551.551 0 0 0 .368.137.551.551 0 0 0 .37-.137l1.536-1.381a.446.446 0 0 0 .152-.332V.47c0-.26-.233-.469-.521-.469Zm-1.537 14.868-1.167-1.049a.553.553 0 0 0-.369-.137.553.553 0 0 0-.369.137l-1.167 1.05-1.168-1.05a.564.564 0 0 0-.737 0l-1.168 1.05-1.167-1.05a.553.553 0 0 0-.369-.137.553.553 0 0 0-.369.137l-1.167 1.05-1.015-.913V.937h11.247v13.02l-1.015.911Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.638 8.232c-.07-.171-.141-.342-.22-.51-.068-.151-.156-.195-.32-.158-.21.048-.414.112-.623.155-.403.084-.808.092-1.206-.034-.499-.157-.765-.519-.928-.985h1.354a.191.191 0 0 0 .191-.192V6.08a.191.191 0 0 0-.191-.192H7.21v-.347h1.484a.191.191 0 0 0 .191-.192v-.426a.191.191 0 0 0-.191-.192H7.398c0-.005 0-.01.003-.013.155-.354.382-.638.754-.786.433-.171.875-.167 1.321-.075.212.043.42.108.63.155.155.035.244-.01.31-.154.077-.166.147-.334.217-.504.066-.16.027-.272-.123-.36a.802.802 0 0 0-.117-.056c-.625-.244-1.27-.335-1.934-.228-.468.075-.905.236-1.283.529-.475.368-.784.854-.963 1.426l-.022.066h-.666a.191.191 0 0 0-.192.192v.426c0 .106.086.192.192.192h.525v.347h-.525a.191.191 0 0 0-.192.192v.427c0 .106.086.192.192.192h.633c.047.155.088.313.149.462.32.773.857 1.323 1.664 1.585.668.216 1.34.21 2.014.024.175-.048.348-.11.514-.186.16-.074.202-.199.139-.353Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgInvoiceOutlinedmin);
export { ForwardRef as ReactComponent };
